<nuc-icon iconClass="stla-profile-new" class="profile-icon {{displayClass}}" size="{{size}} material-icons-outlined"
    [matMenuTriggerFor]="menu" (click)="onClick($event)"></nuc-icon>
<mat-menu #menu="matMenu" class="user-menu-wrapper">
    <div class="loggedInAsLabel">{{(pageContent | contentFilter: LABELS.WELCOME_TEXT) || 'Welcome'}} {{loginData?.userFirstName}}!
    </div>
    <div class="loggedInAsLabel">{{(pageContent | contentFilter: LABELS.LOGGEDIN_AS_TEXT) || 'Logged in as'}}</div>
    <div class="user-menu-details-wrapper">
        <div class="user-menu-details"> 
            <div>
                <span class="userLabel" id="businessAreaLabel">{{(pageContent | contentFilter: LABELS.BUSINESSOP_LABEL) || 'Business Operation'}}</span>
                <span id="businessAreaValue"> : {{selectedBusinessLabel ? selectedBusinessLabel : '-'}}</span>
            </div>
            @if(!loginData?.isIndependentRepairer){
                <div>
                    <span class="userLabel" id="roleLabel">{{(pageContent | contentFilter: LABELS.ROLE_LABEL) || 'Role'}}</span>
                    <span id="roleValue"> : {{selectedRole ? selectedRole : '-'}}</span>
                </div>
            }
            <div>
                @if(selectedBusinessLabel?.toLowerCase() === "ir" ){
                <span class="userLabel" id="dealerCode">{{(pageContent | contentFilter: LABELS.USER_ICON_DEALER_LABEL_IR) ||
                    'Location/Branch'}}</span>
                }
                @else{
                <span class="userLabel" id="dealerCode">{{(pageContent | contentFilter: LABELS.DEALER_LABEL) || 'Dealer/OIC Code'}}</span>
                }
                <span id="dealerValue"> : {{ selectedDealer ? selectedDealer : '-'}}</span>
            </div>
        </div>
        <!-- Pencil icon for role switcher - only for dealers with multiple roles, not for HQ admin users -->
        @if(!loginData?.isAdmin && hasMultipleRoles()){
        <nuc-icon iconClass="edit" size="24 material-icons-outlined" (click)="open()" (keydown.enter)="open()" (keydown.space)="open()" tabindex="0" style="cursor:pointer; margin-left:8px;"></nuc-icon>
        }
    </div>
    <hr>
    <div class="logOut-button" (click)="logOut()">{{(pageContent | contentFilter: LABELS.LOGOUT_LABEL) || 'Log Out'}}</div>
</mat-menu>